import { StyleSheet, View } from 'react-native'
import CheckIcon from '../../../assets/BetRowCheckIcon.svg'

export const Checkbox = ({ selected }: { selected: boolean }) => {
  return <View style={[styles.checkbox, selected ? styles.selected : {}]}>{selected ? <CheckIcon /> : null}</View>
}

const styles = StyleSheet.create({
  checkbox: {
    borderWidth: 1,
    borderColor: 'black',
    borderRadius: 50,
    height: 16,
    width: 16
  },
  selected: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black'
  }
})
